export const BROKER_PIPELINE_LOANS_URL = '/api/command-center/pipeline/loans';
